import { render, staticRenderFns } from "./StatusTab.vue?vue&type=template&id=235d7886&scoped=true&"
import script from "./StatusTab.vue?vue&type=script&lang=ts&"
export * from "./StatusTab.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTab.vue?vue&type=style&index=0&id=235d7886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235d7886",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VProgressCircular,VProgressLinear,VRow})
